import { AUTHORFILTER, CATEGORYFILTER, TITLEFILTER } from "./actionIdentifier";

export const categoryFilter = (value) => {
  return {
    type: CATEGORYFILTER,
    payload: value,
  };
};

export const authorFilter = (value) => {
  return {
    type: AUTHORFILTER,
    payload: value,
  };
};

export const titleFilter = (value) => {
  return {
    type: TITLEFILTER,
    payload: value,
  };
};
